module.exports = __webpack_public_path__ + "img/mobile-44.02224962.png";